import type { FaireProductEntity } from "../../entity_types/product";

export const p_z3ckj6yxve: FaireProductEntity = {
  token: "p_z3ckj6yxve",
  type: "product",
  name: "pretzel case",
  brandToken: "b_zkf5unaq8w",
  brandName: "hey champ",
  imageUrl: "https://cdn.faire.com/fastly/b6f7eed432fa335e33f17fde14266faf1a12c9ec8b73cb4e38c56875154ff700.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/229b51d641c8bd81fda8a2dcc66287c045df625fbfca5668ea4d46cac0e65df0.png",
    "https://cdn.faire.com/fastly/642c4db34183ce89187e977b731961af2173ddae807801f6d9ec44fccd8a6255.png",
    "https://cdn.faire.com/fastly/36ed946faf04fe1f8a06a20f736241b11d4d58896408e4022defd0d0fddfa9ad.png",
    "https://cdn.faire.com/fastly/6c180226ac820cb368b8ff46e6f4a4b48bfc8407190e27285e6392c25fb29c30.png",
    "https://cdn.faire.com/fastly/52e4cf463588f814ca0d987f6cf6ec0f08e965ef157d4ce1e180aa10a16ce9ee.jpeg"
  ],
  priceDollars: 2.95,
  description: "PRETZEL\npretzel shortbread with salted caramel and dark milk chocolate\n\nour best seller! salty pretzels paired with soft caramel - the dream combo - enrobbed in dark milk chocolate :)\n\ningredients: chocolate (cacao bean, cane sugar, cocoa butter), butter, wheat flour, sugar (granulated) , brown rice syrup, milk, cream, pretzel (wheat flour, vegetable oil, salt, butter flavor, brown rice syrup, yeast), sugar (powdered), cocoa butter, salt, cornstarch, coconut oil ",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:22.790Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
